import type { RouteRecordRaw } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
// eslint-disable-next-line import/no-duplicates
import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line import/no-duplicates
import { routes } from 'vue-router/auto-routes'
import { useWorkspaceStore } from '~/stores/workspace'

// 需要重定向的路由集合
const redirectRoutes = [
  {
    path: '/:workspaceId(\\d+)',
    redirect: () => {
      return `/inbox`
    },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes).concat(redirectRoutes as RouteRecordRaw[]),
})

router.beforeEach((to, _from, next) => {
  const workspaceStore = useWorkspaceStore()

  if ('workspaceId' in to.params && to.params.workspaceId) {
    const workspaceId = Number.parseInt(String(to.params.workspaceId))
    if (workspaceStore.workspaceList.length > 0 && !Number.isNaN(workspaceId)) {
      const workspace = workspaceStore.getWorkspaceById(workspaceId)
      if (workspace) {
        workspaceStore.setCurrentWorkspace(workspace)
      }
      else {
        workspaceStore.setCurrentWorkspace(workspaceStore.workspaceList[0])
      }
    }
  }

  next()
})
